/**
 * Replacement for the $(document).ready(callback) or $(callback);
 */
export const ready = function(callback) {
  if (typeof callback !== 'function') return;
  if (document.readyState != 'loading') callback();
  else document.addEventListener('DOMContentLoaded', callback);
};
window.ready = ready;
